import * as React from 'react';
import { IAlanButtonPreviewOptions } from '../../../../models/IAlanButtonPreviewOptions';
import { DeviceMode } from './deviceMode';
import { DEVICE_SIZES } from './deviceSize';
import SimpleTextChatPreview from './SimpleTextChatPreview';


type DevicePreviewProps = {
    html: string
    css: string
    type: string
    deviceBgColor: string
    btnOptions: IAlanButtonPreviewOptions;
    deviceMode: DeviceMode
}

function DevicePreview({
    html,
    css,
    deviceBgColor,
    deviceMode,
    btnOptions,
    type
}: DevicePreviewProps) {
    const [width, height] = DEVICE_SIZES[deviceMode];
    const {
        rightPopupPos,
        bottomPopupPos,
        btnBottomPos,
        buttonSize,
        bgColor1,
        bgColor2,
        logoUrl
    } = btnOptions;

    const isChat = type === 'chat';

    return <div className={`alan-button-popup-settings-form__frame-img ${deviceMode}`}>

        <div className={`alan-button-popup-settings-form__frame-bg ${deviceMode}`} style={{ backgroundColor: deviceBgColor }}>
            {isChat && <SimpleTextChatPreview css={css} html={html} />}
        </div>
        {!isChat && <iframe
            title="preview-frame"
            scrolling="no"
            width={width}
            height={height}
            className={deviceMode}
            srcDoc={`
                <style>
                ._alan-popup-wrapper { position:absolute;right:${rightPopupPos}px;bottom:${bottomPopupPos}px; z-index:9; }
                ._alan-btn-draft {
                    position:fixed;
                    right:20px;
                    bottom:${btnBottomPos}px;
                    min-width:${buttonSize}px;
                    max-width:${buttonSize}px;
                    width:${buttonSize}px;
                    min-height:${buttonSize}px;
                    max-height:${buttonSize}px;
                    height:${buttonSize}px;
                    overflow: hidden;
                    border-radius:50%;
                    z-index:999999;
                    background-image: linear-gradient(122deg,${bgColor1},${bgColor2});
                }
                ._alan-btn-draft img {height:100%;width:100%;}
                </style>
                <style>${css}</style>
                <body>
                    <div class="_alan-popup-wrapper">${html}</div>
                    <div class="_alan-btn-draft">
                    <img src="${logoUrl}">
                </div>
                </body>
                `}
        />}
    </div>;

}

export default DevicePreview;